import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-49c7de92")

_pushScopeId("data-v-49c7de92")
const _hoisted_1 = {
  key: 0,
  class: "filter-holder"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.showFilter)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", {
          class: `filter ${_ctx.currentTag.value == null ? 'selected' : ''}`,
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateCurrentTag(null)))
        }, "All", 2),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tags, (tag, i) => {
          return (_openBlock(), _createBlock("div", {
            class: `filter ${_ctx.currentTag.value == tag ? 'selected' : ''}`,
            innerHTML: tag,
            key: i,
            onClick: ($event: any) => (_ctx.updateCurrentTag(tag))
          }, null, 10, ["innerHTML", "onClick"]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
})